import { render } from "./MinorProtection.vue?vue&type=template&id=146ba433&scoped=true"
import script from "./MinorProtection.vue?vue&type=script&lang=js"
export * from "./MinorProtection.vue?vue&type=script&lang=js"

import "./MinorProtection.vue?vue&type=style&index=0&id=146ba433&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146ba433"]])

export default __exports__